

const initialState = {
    rulesList: [],
    currentRule: {
      facts: [],
      decisions: []
    },
    validationResults: [],
    generatedRuleSet: null,
    error: null
  };
  
export const rulesReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'LOAD_RULES':
        return {
          ...state,
          rulesList: action.payload
        };
      case 'SET_CURRENT_RULE':
        return {
          ...state,
          currentRule: action.payload,
          validationResults: [] // Reset validation results when changing rule
        };
      case 'ADD_RULE':
        return {
          ...state,
          rulesList: [...state.rulesList, action.payload],
          currentRule: action.payload
        };
      case 'ADD_FACT':
        return {
          ...state,
          currentRule: {
            ...state.currentRule,
            facts: [...(state.currentRule.facts || []), action.payload]
          }
        };
      case 'UPDATE_FACT':
        return {
          ...state,
          currentRule: {
            ...state.currentRule,
            facts: (state.currentRule.facts || []).map(fact => 
              fact.id === action.payload.id ? action.payload : fact
            )
          }
        };
      case 'DELETE_FACT':
        return {
          ...state,
          currentRule: {
            ...state.currentRule,
            facts: (state.currentRule.facts || []).filter(fact => fact.id !== action.payload)
          }
        };
        
      case 'ADD_DECISION':
        return {
          ...state,
          currentRule: {
            ...state.currentRule,
            decisions: [...(state.currentRule.decisions || []), action.payload]
          }
        };
  
        case 'UPDATE_DECISION':
      return {
          ...state,
          currentRule: {
              ...state.currentRule,
              decisions: state.currentRule.decisions.map(decision => 
                  decision.id === action.payload.id ? action.payload : decision
              )
          }
      };
      
      case 'DELETE_DECISION':
        return {
          ...state,
          currentRule: {
            ...state.currentRule,
            decisions: (state.currentRule.decisions || []).filter(decision => decision.id !== action.payload)
          }
        };
      case 'SET_VALIDATION_RESULTS':
        return {
          ...state,
          validationResults: action.payload,
          error: null
        };
    
      case 'SET_VALIDATION_RESULTS':
    return {
      ...state,
      validationResults: action.payload,
      error: null
    };
    case 'CLEAR_VALIDATION_RESULTS':
    return {
      ...state,
      validationResults: [],
      error: null
    };
  
      case 'SET_GENERATED_RULESET':
        return {
          ...state,
          generatedRuleSet: action.payload
        };
      default:
        return state;
    }
  };
  
